export const themes = [
  {
    name: "Hue 0",
    colors: {
      bg: "hsl(0, 100%, 10%)",
      bgVariant: "hsl(0, 100%, 20%)",
      primary: "hsl(120, 100%, 60%)",
      primaryVariant: "hsla(120, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 18",
    colors: {
      bg: "hsl(18, 100%, 10%)",
      bgVariant: "hsl(18, 100%, 20%)",
      primary: "hsl(138, 100%, 60%)",
      primaryVariant: "hsla(138, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 36",
    colors: {
      bg: "hsl(36, 100%, 10%)",
      bgVariant: "hsl(36, 100%, 20%)",
      primary: "hsl(156, 100%, 60%)",
      primaryVariant: "hsla(156, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 54",
    colors: {
      bg: "hsl(54, 100%, 10%)",
      bgVariant: "hsl(54, 100%, 20%)",
      primary: "hsl(174, 100%, 60%)",
      primaryVariant: "hsla(174, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 72",
    colors: {
      bg: "hsl(72, 100%, 10%)",
      bgVariant: "hsl(72, 100%, 20%)",
      primary: "hsl(192, 100%, 60%)",
      primaryVariant: "hsla(192, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 90",
    colors: {
      bg: "hsl(90, 100%, 10%)",
      bgVariant: "hsl(90, 100%, 20%)",
      primary: "hsl(210, 100%, 60%)",
      primaryVariant: "hsla(210, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 108",
    colors: {
      bg: "hsl(108, 100%, 10%)",
      bgVariant: "hsl(108, 100%, 20%)",
      primary: "hsl(228, 100%, 60%)",
      primaryVariant: "hsla(228, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 126",
    colors: {
      bg: "hsl(126, 100%, 10%)",
      bgVariant: "hsl(126, 100%, 20%)",
      primary: "hsl(246, 100%, 60%)",
      primaryVariant: "hsla(246, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 144",
    colors: {
      bg: "hsl(144, 100%, 10%)",
      bgVariant: "hsl(144, 100%, 20%)",
      primary: "hsl(264, 100%, 60%)",
      primaryVariant: "hsla(264, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 162",
    colors: {
      bg: "hsl(162, 100%, 10%)",
      bgVariant: "hsl(162, 100%, 20%)",
      primary: "hsl(282, 100%, 60%)",
      primaryVariant: "hsla(282, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 180",
    colors: {
      bg: "hsl(180, 100%, 10%)",
      bgVariant: "hsl(180, 100%, 20%)",
      primary: "hsl(300, 100%, 60%)",
      primaryVariant: "hsla(300, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 198",
    colors: {
      bg: "hsl(198, 100%, 10%)",
      bgVariant: "hsl(198, 100%, 20%)",
      primary: "hsl(318, 100%, 60%)",
      primaryVariant: "hsla(318, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 216",
    colors: {
      bg: "hsl(216, 100%, 10%)",
      bgVariant: "hsl(216, 100%, 20%)",
      primary: "hsl(336, 100%, 60%)",
      primaryVariant: "hsla(336, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 234",
    colors: {
      bg: "hsl(234, 100%, 10%)",
      bgVariant: "hsl(234, 100%, 20%)",
      primary: "hsl(354, 100%, 60%)",
      primaryVariant: "hsla(354, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 252",
    colors: {
      bg: "hsl(252, 100%, 10%)",
      bgVariant: "hsl(252, 100%, 20%)",
      primary: "hsl(12, 100%, 60%)",
      primaryVariant: "hsla(12, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 270",
    colors: {
      bg: "hsl(270, 100%, 10%)",
      bgVariant: "hsl(270, 100%, 20%)",
      primary: "hsl(30, 100%, 60%)",
      primaryVariant: "hsla(30, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 288",
    colors: {
      bg: "hsl(288, 100%, 10%)",
      bgVariant: "hsl(288, 100%, 20%)",
      primary: "hsl(48, 100%, 60%)",
      primaryVariant: "hsla(48, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 306",
    colors: {
      bg: "hsl(306, 100%, 10%)",
      bgVariant: "hsl(306, 100%, 20%)",
      primary: "hsl(66, 100%, 60%)",
      primaryVariant: "hsla(66, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 324",
    colors: {
      bg: "hsl(324, 100%, 10%)",
      bgVariant: "hsl(324, 100%, 20%)",
      primary: "hsl(84, 100%, 60%)",
      primaryVariant: "hsla(84, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  },
  {
    name: "Hue 342",
    colors: {
      bg: "hsl(342, 100%, 10%)",
      bgVariant: "hsl(342, 100%, 20%)",
      primary: "hsl(102, 100%, 60%)",
      primaryVariant: "hsla(102, 100%, 60%, 0.4)",
      white: "#fff",
      light: "rgba(255, 255, 255, 0.6)"
    }
  }
];